import { render, staticRenderFns } from "./TbWorkPermitData.vue?vue&type=template&id=33f24530&scoped=true"
import script from "./TbWorkPermitData.vue?vue&type=script&lang=js"
export * from "./TbWorkPermitData.vue?vue&type=script&lang=js"
import style0 from "./TbWorkPermitData.vue?vue&type=style&index=0&id=33f24530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f24530",
  null
  
)

export default component.exports